import Vue from 'vue';
import styled from 'vue-styled-components';
import COLORS from '@design/colors.js';
import { square } from '@styles/common.styled';

import { Switch } from 'ant-design-vue';

export default {
    name: 'CommonSwitch',
    props: {
        value: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        emphasize: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'big', //big | small | xSmall
        },
        deactivated: {
            type: Boolean,
            default: false,
        },
        addEvents: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        if (this.emphasize && !this.value) {
            this.animte = true;
        }
    },
    data() {
        return {
            animate: false,
        };
    },
    render() {
        const { value, disabled, deactivated, addEvents } = this;

        let PROPS = {
            attrs: {
                checked: value,
                disabled,
            },
        };

        if (addEvents) {
            PROPS = {
                ...PROPS,
                on: {
                    change: () => this.$emit('update:value', R.not(value)),
                },
                nativeOn: {
                    click: (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        !deactivated && this.$emit('click');
                    },
                },
            };
        }

        return <CommonSwitch class={this.className} {...PROPS} />;
    },
    computed: {
        className() {
            const { animate, type, deactivated } = this;
            return [
                'adriel-switch',
                animate ? 'animate' : '',
                type,
                deactivated ? 'deactivated' : '',
            ].filter(R.identity);
        },
    },
};

const CommonSwitch = styled(Vue.component('adriel-switch-common', Switch))`
    @keyframes translate-right {
        0% {
            transform: translate3d(0%, 0, 0);
        }
        25% {
            transform: translate3d(50%, 0, 0);
        }
        100% {
            transform: translate3d(125%, 0, 0);
        }
    }
    @keyframes color-ani {
        100% {
            background-color: ${COLORS['blue-60']};
        }
    }

    border: none;
    border-radius: 12px;

    &.ant-switch {
        background-color: ${COLORS['gray-25']};

        &.ant-switch-disabled {
            opacity: 1;
        }

        &::after {
            margin-left: 4px;
            /* top: 3px !important; */
        }

        &-checked {
            background-color: ${COLORS['blue-60']};
            &::after {
                margin-left: -4px;
            }
        }

        &[disabled='disabled'],
        &.deactivated {
            position: relative;
            &::before {
                content: '';
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                position: absolute;
                border-radius: 12px;
                background-color: rgba(0, 0, 0, 0.2);
                z-index: 2;
                pointer-events: none;
            }
        }

        &.deactivated {
            &::before {
                pointer-events: initial;
                cursor: not-allowed;
            }
            &::after {
                background-color: ${COLORS['gray-30']};
                top: 50% !important;
                transform: translateY(-50%);
            }
            &.ant-switch-checked {
                &::after {
                    transform: translate(-100%, -50%);
                }
            }
        }
    }

    &.animate {
        &::after {
            animation-delay: 0.5s;
            animation: translate-right 1.5s linear 2;
        }
        animation: color-ani 1.5s linear 2;
    }

    &.big {
        height: 24px;
        width: 44px;

        &.ant-switch {
            &::after {
                ${square(16)};
                top: 50%;
                transform: translateY(-50%);
            }
        }

        &.ant-switch-checked {
            &::after {
                transform: translate(-100%, -50%);
            }
        }
    }

    &.small {
        height: 20px;
        width: 36px;
        min-width: 36px;

        &.ant-switch {
            &::after {
                ${square(14)};
                top: 50% !important;
                transform: translateY(-50%);
            }
        }

        &.ant-switch-checked {
            &::after {
                transform: translate(-100%, -50%);
            }
        }
    }

    &.xSmall {
        min-width: 32px;
        height: 16px;

        &.ant-switch {
            &::after {
                ${square(12)};
                top: 50% !important;
                transform: translate(2px, -50%);
                margin-left: 0px;
            }
        }

        &.ant-switch-checked {
            &::after {
                transform: translate(-14px, -50%) !important;
            }
        }
    }
`;
